import applyInstances from '@/services/functions/apply-instances';
import updateFormDictonary from './updateFormDictionary';

export default function createUpdateRequest(formData) {
  const request = applyInstances({}, formData, updateFormDictonary);

  return request;
}
